module.exports = __webpack_public_path__ + "img/footer-bird-friendly.caefd9c8.png";